<template>
    <v-flex style="position: relative; top: 20%; margin:0 auto;">
        <v-card class="mx-auto text-center" max-width="700">        
            <div style="width:100%; height:370px">
                <h2 class="text-left pl-5 pt-5">E3 Mobility</h2>
                <div class="text-center">
                    <div class="mt-10 pt-5 mb-8"><v-icon x-large>mdi-access-point-off</v-icon></div>
                    <h4 class="font-weight-block">Internal Server Error(500)</h4>
                    <p>Sorry, something weebt wrong.</p>
                </div>
                <div style="width:100%; height:60px; margin-top:40px;">
                    <v-btn style="width:150px;height:50px;font-size:18px;font-weight:800;color:#fff;background-color:#2C4F91;"  @click="goHome">Home</v-btn>
                </div>
            </div>
        </v-card>
    </v-flex>
</template>

<script>
export default {
  name:"ServerError", 
  methods: {
    goHome() {
      this.$router.replace('/');
    },
  },
};
</script>